import React from 'react';

import Icon from '../Icon/Icon';

const ResponsiveDrawNoneBlueIcon = (props) => {
    return (
        <Icon width='48' height='48' {...props}>
            <g transform='translate(6 6)' strokeWidth='2' fill='none' fillRule='evenodd'>
                <circle stroke='#272A33' cx='18' cy='18' r='17' />
                <path stroke='#272A33' strokeLinecap='round' d='M29 7 7 29' />
                <path
                    stroke='#00D1D2'
                    strokeLinecap='round'
                    d='M23.36 6 17 12.364M19 23.64 12.636 30'
                    className='icon-accent-stroke icon-accent-fill'
                />
            </g>
        </Icon>
    );
};

export default ResponsiveDrawNoneBlueIcon;
